module.exports = __webpack_public_path__ + "static/media/hashtag_event.ca99c376.png";